module.exports = __webpack_public_path__ + "img/afterlife_logo_home.fc4e715a.svg";